import { Component, ElementRef, EventEmitter, Inject, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AbstractCreateEntityComponent } from '@abstracts/entities/create-entity';
import { UsersService } from '@services/entity/users.service';
import { CustomersService } from '@services/entity/customers.service';
import { User } from '@models/identity/user';
import { SendInviteRequest } from '@dto/sendInviteRequest';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { DOCUMENT, NgIf } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { StripeInfo } from '@models/stripeInfo';

@Component({
  selector: 'app-create-customer',
  templateUrl: './create-customer.component.html',
  styleUrls: ['./create-customer.component.scss']
})
export class CreateCustomerComponent extends AbstractCreateEntityComponent implements OnInit {

  public className = 'CreateCustomerComponent';

  @Input() customerId: number;

  @Output() newCustomerEvent = new EventEmitter<User>();

  public inviteLink: string;

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    private usersService: UsersService,
    private customersService: CustomersService,
    private stripeInfosService: StripeInfosService,
    private spinner: NgxSpinnerService,
    injector: Injector) {
    super(usersService, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  createForm() {
    this.formService.form = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      firstName: new UntypedFormControl('', [Validators.pattern('^[\u00C0-\u017Fa-zA-Z0-9]+(?:[\\s-][\u00C0-\u017Fa-zA-Z0-9]+)*$')]),
      lastName: new UntypedFormControl('', [Validators.required, Validators.pattern('^[\u00C0-\u017Fa-zA-Z0-9]+(?:[\\s-][\u00C0-\u017Fa-zA-Z0-9]+)*$')]),
    });
  }

  onSubmit(formValue) {
    this.spinner.show();

    var user = new User(formValue);

    if (this.customerId) {
      this.usersService.createUserForCustomer(this.customerId, user).subscribe(data => {
        this.sendInviteEmail(user);
      }, error => {
        this.messageService.setError(error);
        this.spinner.hide();
      });
    } else {
      this.usersService.createUserForCurrentCustomer(user).subscribe(data => {
        this.sendInviteEmail(user);
      }, error => {
        this.messageService.setError(error);
        this.spinner.hide();
      });
    }
  }

  sendInviteEmail(user: User) {
    const sendInviteRequest: SendInviteRequest = {
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      clientURI: this.baseUrl + 'auth/register',
      invitingCustomerId: this.customerId ? this.customerId : 0
    }

    this.authenticationService.sendInvite(sendInviteRequest).subscribe(result => {
      this.inviteLink = result.inviteLink;
      var input: HTMLInputElement = <HTMLInputElement>document.getElementById('inviteLink');
      input.value = result.inviteLink;
      this.spinner.hide();
      this.newCustomerEvent.emit(user);
    }, error => {
      this.spinner.hide();
    })
  }

  copyInviteLink() {
    var input: HTMLInputElement = <HTMLInputElement>document.getElementById('inviteLink');
    input.select();
    document.execCommand('copy');
  }
}
